module.exports = __webpack_public_path__ + "static/img/2.6d24e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/2.jpg
// module id = i2cM
// module chunks = 1